import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { BuyToneRequest } from './buytonerequest';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class BuyToneAPI extends SixdeeCRBTAPI<BuyToneRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/set-tone
        return "set-tone";
    }

    getRequestData()
    {
        console.log("---tiger"+this.getRequest().getBuyToneRequest().getLanguage());
            return "msisdn="+ this.getRequest().getBuyToneRequest().getMsisdn()+"&"+
            "toneId="+ this.getRequest().getBuyToneRequest().getToneId()+"&"+
            "toneName="+ this.getRequest().getBuyToneRequest().getToneName()+"&"+
            "packName="+ this.getRequest().getBuyToneRequest().getPackName()+"&"+
            "username="+ this.getRequest().getBuyToneRequest().getUserName()+"&"+
            "language="+ (this.getRequest().getBuyToneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2")+
            "&"+"channel="+ this.getRequest().getBuyToneRequest().getChannel();
        // }
        // else
        // {
        //     return "msisdn="+ this.getRequest().getBuyToneRequest().getMsisdn()+"&"+
        //     "toneId="+ this.getRequest().getBuyToneRequest().getToneId()+"&"+
        //     "toneName="+ this.getRequest().getBuyToneRequest().getToneName()+"&"+
        //     "packName="+ this.getRequest().getBuyToneRequest().getPackName()+"&"+
        //     "language="+ (this.getRequest().getBuyToneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2");
        // }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/buytune/buytoneapi.tsx